import { z } from 'zod';
export const ReviewActionSchema = z.enum([
    'not_issue',
    'needs_correction',
    'waiting',
    'correction_recorded',
    'corrected',
    'reopen',
]);
export const REVIEW_ACTION_LABELS = {
    not_issue: 'Not an issue',
    needs_correction: 'Needs correction',
    waiting: 'Waiting for response',
    correction_recorded: 'Record correction',
    corrected: 'Correction made',
    reopen: 'Reopen',
};
export const REVIEW_DECISION_LABELS = {
    not_issue: 'Closed by reviewer',
    needs_correction: 'Needs correction',
    waiting: 'Waiting for response',
    correction_recorded: 'Correction recorded',
    corrected: 'Resolved by reviewer',
    reopen: 'Needs review',
};
/** Human closure is separate from an analysis result. */
export function closesReview(action) {
    return action === 'not_issue' || action === 'corrected';
}
export const ReviewDecisionSchema = z.object({
    id: z.string(),
    action: ReviewActionSchema,
    note: z.string(),
    source_version: z.string(),
    created_at: z.string(),
    actor_name: z.string().nullable(),
    reviewed_run_id: z.string().nullable().optional(),
});
export const ReviewHistorySchema = z.object({
    id: z.string(),
    action: z.string(),
    source_version: z.string().nullable(),
    created_at: z.string(),
    actor_name: z.string().nullable(),
    details: z.record(z.string(), z.unknown()),
});
export const IssueDecisionMutationSchema = z
    .object({
    action: ReviewActionSchema,
    note: z.string().trim().min(1).max(4000),
    source_version: z.string().min(1),
    expected_updated_at: z.string().datetime({ offset: true }),
    expected_decision_id: z.string().uuid().nullable(),
    evidence: z
        .array(z
        .object({
        kind: z.enum(['document', 'measurement_assessment']),
        id: z.string().uuid(),
    })
        .strict())
        .max(50)
        .default([]),
})
    .strict();
